import { FaPhone } from "react-icons/fa6";
import { GiMountains } from "react-icons/gi";
import { MdOutlineVisibility } from "react-icons/md";
import CircleIconAnimationButton from "../../components/ui/circle-icon-animation-button";

const AboutSignService = () => {
  return (
    <section className="w-full h-auto lg:h-screen flex items-center justify-center bg-[#111212] overflow-hidden p-6 lg:px-20 lg:py-6">
      <div className="container mx-auto h-full flex items-center">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {/* Image Container */}
          <div className="relative w-full h-[220px] sm:h-[300px] lg:h-[70vh] xl:h-[75vh] overflow-hidden rounded-2xl group shadow-2xl shadow-black/50">
            <img
              src="https://cdn.shopify.com/s/files/1/0771/9691/9043/files/pexels-bertellifotografia-1789335.jpg?v=1773145857"
              className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-1000"
              alt="Sign Installation"
            />
            <div className="absolute inset-0 bg-linear-to-t from-[#111212]/40 to-transparent" />
          </div>

          {/* Content Container */}
          <div className="flex flex-col justify-center gap-4 lg:gap-6">
            <div className="flex flex-col gap-3">
              <div className="bg-[#4c94ba]/10 text-[#4c94ba] px-3 py-1 rounded-full w-fit text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em] border border-[#4c94ba]/20">
                Learn about us
              </div>

              <h1 className="text-2xl sm:text-3xl lg:text-3xl xl:text-4xl font-bold text-white leading-[1.15] tracking-tight">
                Professional Sign Installation{" "}
                <br className="hidden xl:block" />
                <span className="text-[#4c94ba]">Services You Can Trust</span>
              </h1>

              <p className="text-white/50 text-sm sm:text-base leading-relaxed max-w-lg font-light">
                Our team provides professional sign installation and signage
                solutions for businesses of all sizes, from custom fabrication
                to expert maintenance.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 my-1">
              <div className="flex gap-3">
                <div className="bg-[#4c94ba]/10 w-10 h-10 shrink-0 rounded-xl text-[#4c94ba] text-lg flex items-center justify-center border border-[#4c94ba]/10">
                  <GiMountains />
                </div>
                <div className="space-y-0.5">
                  <h3 className="font-bold text-sm sm:text-base text-white">
                    Our Mission
                  </h3>
                  <p className="text-white/40 text-[10px] sm:text-xs leading-tight">
                    High-quality signage that helps businesses increase
                    visibility.
                  </p>
                </div>
              </div>

              <div className="flex gap-3">
                <div className="bg-[#4c94ba]/10 w-10 h-10 shrink-0 rounded-xl text-[#4c94ba] text-lg flex items-center justify-center border border-[#4c94ba]/10">
                  <MdOutlineVisibility />
                </div>
                <div className="space-y-0.5">
                  <h3 className="font-bold text-sm sm:text-base text-white">
                    Our Vision
                  </h3>
                  <p className="text-white/40 text-[10px] sm:text-xs leading-tight">
                    Trusted partner for modern signage and innovative branding.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-6 mt-2">
              <CircleIconAnimationButton className="w-fit">
                Learn More
              </CircleIconAnimationButton>

              <div className="flex items-center gap-3">
                <div className="bg-white/5 p-3 text-[#4c94ba] rounded-xl border border-white/5">
                  <FaPhone className="text-xs sm:text-sm" />
                </div>
                <div>
                  <p className="text-[10px] text-white/30 uppercase tracking-widest font-semibold">
                    Available 24/7
                  </p>
                  <p className="font-bold text-white text-sm sm:text-base">
                    +1.780.975.2558
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSignService;
